export class NoDataFoundError extends Error {
  functionName: string;
  params: object;

  constructor(message: string, functionName: string, params: any) {
    super(message);
    this.name = 'NoDataFoundError';
    this.functionName = functionName;
    this.params = params;
  }
}

export class InvalidDataFoundError extends Error {
  functionName: string;
  data: object;
  validationErrors: any;

  constructor(
    message: string,
    functionName: string,
    data: object,
    validationErrors: any
  ) {
    super(message);
    this.name = 'InvalidDataFoundError';
    this.functionName = functionName;
    this.data = data;
    this.validationErrors = validationErrors;
  }
}
